
import React, { useEffect } from 'react';
import { DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { SimpleCollectionForm } from './components/SimpleCollectionForm';
import { CollectionFormProvider } from './context/CollectionFormContext';
import { useCollectionSearch } from './hooks/useCollectionSearch';
import { useCollectionData } from './hooks/useCollectionData';
import { fetchCouriersList } from './services/courierService';
import { useCollectionForm } from './context/CollectionFormContext';

interface CollectionDialogContentProps {
  onClose: () => void;
  onOpenChange?: (open: boolean) => void;
  showOnlyWithPaymentData?: boolean;
  open?: boolean;
}

// Внутренний компонент для доступа к контексту
const CollectionDialogInner = ({ onClose, onOpenChange }: { onClose: () => void; onOpenChange?: (open: boolean) => void }) => {
  // Передаем колбэк закрытия диалога в хук useCollectionData
  const { loadCourierPaymentData, handleSubmit } = useCollectionData({
    onSuccess: () => {
      console.log('Колбэк onSuccess вызван после успешного создания взыскания');
      // Не закрываем диалог автоматически, т.к. теперь показываем статус транзакции
      // Пользователь сам закроет диалог или создаст новое взыскание
    }
  });
  
  const { loadCouriers } = useCollectionSearch();
  const { 
    selectedCourierId, 
    setLoading, 
    setFilteredCouriers
  } = useCollectionForm();
  
  // Загружаем список курьеров при открытии диалога
  useEffect(() => {
    const loadInitialData = async () => {
      setLoading(true);
      try {
        const couriersData = await fetchCouriersList();
        console.log('Загружен список курьеров:', couriersData.length);
        loadCouriers(couriersData); // Сначала устанавливаем все данные
        setFilteredCouriers(couriersData); // И начальное состояние для фильтрации
      } catch (error) {
        console.error('Ошибка при загрузке курьеров:', error);
      } finally {
        setLoading(false);
      }
    };
    
    loadInitialData();
  }, [loadCouriers, setFilteredCouriers, setLoading]);
  
  // Загружаем данные платежных методов при выборе курьера
  useEffect(() => {
    if (selectedCourierId) {
      console.log('Загрузка платежных методов для курьера:', selectedCourierId);
      loadCourierPaymentData(selectedCourierId);
    }
  }, [selectedCourierId, loadCourierPaymentData]);
  
  return (
    <SimpleCollectionForm 
      onSubmit={handleSubmit} 
      onCancel={onClose} 
    />
  );
};

export const CollectionDialogContent: React.FC<CollectionDialogContentProps> = ({ 
  onClose, 
  onOpenChange,
  showOnlyWithPaymentData = true
}) => {
  return (
    <DialogContent className="sm:max-w-[500px]">
      <DialogHeader>
        <DialogTitle>Создание взыскания</DialogTitle>
        <DialogDescription>Выберите курьера и заполните данные для создания взыскания</DialogDescription>
      </DialogHeader>
      
      <CollectionFormProvider initialShowWithPayment={showOnlyWithPaymentData}>
        <CollectionDialogInner onClose={onClose} onOpenChange={onOpenChange} />
      </CollectionFormProvider>
    </DialogContent>
  );
};
